module.exports = __webpack_public_path__ + "img/menu_pay.baeed1ec.svg";